import React, { Component } from 'react';
import {
    Box, Grid, Chip, Checkbox, FormControlLabel, TextField, Button,
    TableHead, TableBody, TableRow, TableCell, Typography,
} from '@material-ui/core';
import { RefreshRounded, ReportProblemRounded } from '@material-ui/icons';

import { TableLayout } from '../../Menu/Stock/containers/Layout';
import PageAdmin from '../Layouts/PageAdmin';
import Spin from '../../../commonModules/interface/Spin';
import ProductRow from './ProductRow';

/**
 * Vrai si deux comptes n'appliquent pas le meme prix a ce produit canonique.
 */
export function hasPriceGap(produit) {
    const comptes = Array.isArray(produit.comptes) ? produit.comptes : []
    if (comptes.length < 2) {
        return false
    }
    const premier = comptes[0]
    return comptes.some((compte) => (
        compte.prix_venteHT !== premier.prix_venteHT
        || compte.prix_venteTTC !== premier.prix_venteTTC
    ))
}

/** Recherche sur la reference, le nom et la marque. */
export function matchSearch(produit, search) {
    if (!search) {
        return true
    }
    const recherche = search.toLocaleLowerCase()
    return ["ref", "name", "marque"].some((champ) => (
        typeof produit[champ] === "string"
        && produit[champ].toLocaleLowerCase().indexOf(recherche) > -1
    ))
}

class Products extends Component {
    state = {
        search: "",
        onlyCollision: false,
        onlyMultiAccount: false,
        onlyPriceGap: false,
        withStock: false,
    }

    componentDidMount = () => {
        // Jamais include_stock au premier rendu : l'option est couteuse cote
        // storehouse, l'utilisateur la demande explicitement via la case.
        this.props.fetchSuperAdminProducts(false)
    }

    handleSearch = (e) => {
        this.setState({ search: e.target.value })
    }

    toggleFilter = (name) => (e) => {
        this.setState({ [name]: e.target.checked })
    }

    toggleStock = (e) => {
        const withStock = e.target.checked
        this.setState({ withStock })
        this.props.fetchSuperAdminProducts(withStock)
    }

    reload = () => {
        this.props.fetchSuperAdminProducts(this.state.withStock)
    }

    render() {
        const STORE = this.props.SUPERADMIN_PRODUCTS || {}
        const produits = Array.isArray(STORE.produits) ? STORE.produits : []
        const totaux = STORE.totaux || {}
        const { loading, error, loaded } = STORE
        // withStock du store : reflete ce qui est reellement charge, pas ce que
        // la case a coche pendant que la requete est encore en vol.
        const withStock = !!STORE.withStock

        const decores = produits.map((produit) => ({
            produit,
            priceGap: hasPriceGap(produit),
        }))

        const visibles = decores.filter(({ produit, priceGap }) => {
            if (!matchSearch(produit, this.state.search)) {
                return false
            }
            if (this.state.onlyCollision && !produit.en_collision) {
                return false
            }
            if (this.state.onlyMultiAccount) {
                const comptes = Array.isArray(produit.comptes) ? produit.comptes : []
                if (comptes.length < 2) {
                    return false
                }
            }
            if (this.state.onlyPriceGap && !priceGap) {
                return false
            }
            return true
        })

        return (
            <PageAdmin title="Produits - tous les comptes">
                {loading && <Spin />}

                <Box
                    p={1}
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}
                >
                    <Box>
                        <Chip
                            label={"Produits canoniques : " + (totaux.produits_canoniques || 0)}
                            style={{ marginRight: 8, marginTop: 4 }}
                        />
                        <Chip
                            label={"Fiches absorbees : " + (totaux.fiches_absorbees || 0)}
                            style={{ marginRight: 8, marginTop: 4 }}
                        />
                        <Chip
                            color={totaux.produits_en_collision ? "secondary" : "default"}
                            label={"En collision : " + (totaux.produits_en_collision || 0)}
                            style={{ marginRight: 8, marginTop: 4 }}
                        />
                        <Chip
                            label={"Comptes : " + (totaux.comptes || 0)}
                            style={{ marginRight: 8, marginTop: 4 }}
                        />
                    </Box>
                    <Button
                        onClick={this.reload}
                        color="primary"
                        startIcon={<RefreshRounded />}
                        disabled={!!loading}
                    >
                        Recharger
                    </Button>
                </Box>

                {error &&
                    <Box p={2} style={{ display: "flex", alignItems: "center" }}>
                        <ReportProblemRounded color="error" style={{ marginRight: 8 }} />
                        <Box>
                            <Typography variant="body1" color="error">{error}</Typography>
                            <Button onClick={this.reload} color="primary" size="small">
                                Reessayer
                            </Button>
                        </Box>
                    </Box>
                }

                {!error &&
                    <React.Fragment>
                        <Box p={1}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        name="search"
                                        id="search"
                                        label="Rechercher"
                                        placeholder="Reference, nom ou marque"
                                        value={this.state.search}
                                        onChange={this.handleSearch}
                                    />
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.onlyCollision}
                                                onChange={this.toggleFilter("onlyCollision")}
                                                color="secondary"
                                            />
                                        }
                                        label="En collision"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.onlyMultiAccount}
                                                onChange={this.toggleFilter("onlyMultiAccount")}
                                                color="primary"
                                            />
                                        }
                                        label="Vendus par plus d'un compte"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.onlyPriceGap}
                                                onChange={this.toggleFilter("onlyPriceGap")}
                                                color="primary"
                                            />
                                        }
                                        label="Prix differents entre comptes"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={this.state.withStock}
                                                onChange={this.toggleStock}
                                                color="primary"
                                            />
                                        }
                                        label="Charger le stock (plus lent)"
                                    />
                                </Grid>
                            </Grid>
                        </Box>

                        <Box p={1}>
                            <Typography variant="caption" color="textSecondary">
                                {visibles.length + " produit(s) affiche(s) sur " + produits.length}
                            </Typography>
                        </Box>

                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="checkbox" />
                                    <TableCell>Reference</TableCell>
                                    <TableCell>Nom</TableCell>
                                    <TableCell>Marque</TableCell>
                                    <TableCell align="right">Comptes</TableCell>
                                    <TableCell align="right">Fiches absorbees</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {visibles.map(({ produit, priceGap }, index) => (
                                    <ProductRow
                                        key={produit.id || produit.ref || index}
                                        produit={produit}
                                        priceGap={priceGap}
                                        withStock={withStock}
                                    />
                                ))}
                            </TableBody>
                        </TableLayout>

                        {!loading && loaded && visibles.length === 0 &&
                            <Box p={2}>
                                <Typography variant="body2" color="textSecondary">
                                    {produits.length === 0
                                        ? "Aucun produit remonte par le storehouse."
                                        : "Aucun produit ne correspond a la recherche ou aux filtres."
                                    }
                                </Typography>
                            </Box>
                        }
                    </React.Fragment>
                }
            </PageAdmin>
        );
    }
}

export default Products;
